/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Valid_FromInputs */

const cs_contracts_valid_from = /** @type {(inputs: Contracts_Valid_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platnost od`)
};

const en_contracts_valid_from = /** @type {(inputs: Contracts_Valid_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid from`)
};

/**
* | output |
* | --- |
* | "Valid from" |
*
* @param {Contracts_Valid_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_valid_from = /** @type {((inputs?: Contracts_Valid_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Valid_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_valid_from(inputs)
	return cs_contracts_valid_from(inputs)
});